if (!customElements.get('product-review-button')) {
  customElements.define('product-review-button', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.product__write-review');
      this.openReview = event => {
        event.preventDefault();
        event.stopPropagation();
        const trigger = this.findReviewTrigger();
        if (trigger) trigger.click();
        this.updateButton();
      };
      this.button.addEventListener('click', this.openReview);
      this.observer = new MutationObserver(() => this.updateButton());
      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'v-cloak']
      });
      this.updateButton();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.openReview);
    }

    findReviewTrigger() {
      for (const widget of document.querySelectorAll('.yotpo-widget-instance[data-yotpo-product-id]')) {
        if (widget.dataset.yotpoProductId !== this.dataset.productId) continue;
        const trigger = widget.querySelector('.yotpo-new-review-btn');
        if (trigger && !trigger.disabled && trigger.getAttribute('aria-disabled') !== 'true') {
          return trigger;
        }
      }
      return null;
    }

    updateButton() {
      const summary = this.querySelector(
        '.product__review-stars .yotpo-reviews-star-ratings-widget:not([v-cloak]) .yotpo-sr-bottom-line-summary'
      );
      const ratingReady = Boolean(summary?.querySelector('svg') && summary.querySelector('.yotpo-sr-bottom-line-text'));
      if (ratingReady) {
        let line = summary.parentElement;
        if (!line.classList.contains('product__review-line')) {
          line = document.createElement('div');
          line.className = 'product__review-line';
          summary.before(line);
          line.appendChild(summary);
        }
        if (summary.nextElementSibling !== this.button) line.appendChild(this.button);
        if (this.ratingLine && this.ratingLine !== line && this.ratingLine.childElementCount === 0) {
          this.ratingLine.remove();
        }
        this.ratingLine = line;
      }
      const hidden = !ratingReady;
      if (this.button.hidden !== hidden) this.button.hidden = hidden;
      const disabled = !this.findReviewTrigger();
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
    }
  });
}
